exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#blockContent {\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  right: 100%;\n  bottom: 100%;\n  z-index: -9999999;\n  visibility: hidden;\n  display: none; }\n  #blockContent.visible {\n    z-index: 9999999;\n    visibility: visible;\n    display: block; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /builds/cp/frap/t3/planer/src/app/app.component.scss
// module id = ../../../../../src/app/app.component.scss
// module chunks = main